import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { CropApi } from '../../types';

interface CatalogState {
  crops: CropApi[];
}

const initialState: CatalogState = {
  crops: [],
};

export const catalogSlice = createSlice({
  name: 'catalog',
  initialState,
  reducers: {
    getCropsList: (state, { payload }: PayloadAction<CropApi[]>) => {
      state.crops = payload;
      return state;
    },
  },
  extraReducers: () => {},
});

export const { getCropsList } = catalogSlice.actions;
